import styled, { css } from 'styled-components'
import HueComponent from './hue'
import ValueComponent from './value'

export const Container = styled.div<{ disabled: boolean }>`
    display: flex;
    flex-direction: column;

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`

export const Hue = styled(HueComponent)`
    flex-shrink: 0;
    width: 100%;
`

export const Value = styled(ValueComponent)`
    height: 100%;
    margin-bottom: 14px;
    width: 100%;
`
